import {
  Badge,
  Box,
  Column,
  Columns,
  Heading,
  Link,
  Stack,
  Text,
  useResponsiveValue,
} from 'braid-design-system';

import * as styles from './SavedRecentSearches.css';

export interface SavedRecentSearch {
  label: string;
  count?: string;
  summary?: string;
  href: string;
}

export interface SavedRecentSearchItemProps {
  searchItem: SavedRecentSearch;
  icon: JSX.Element;
  onClick?: () => void;
}

export const SavedRecentSearchItem = ({
  searchItem,
  icon,
  onClick,
}: SavedRecentSearchItemProps) => {
  const { label, count, summary, href } = searchItem;

  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false,
  });
  const isWide = useResponsiveValue()({
    mobile: false,
    wide: true,
  });

  if (!href) {
    return null;
  }

  return (
    <Link href={href} onClick={onClick}>
      <Box
        width="full"
        className={{ [styles.searchItem]: true, [styles.menuItem]: true }}
      >
        {/* Collapse these columns when the keyword input box is too small (i.e. only for desktop and tablet, not mobile as all three input boxes are collapsed instead */}
        <Columns
          space="small"
          alignY="center"
          collapseBelow={isMobile ? undefined : 'wide'}
        >
          {/* We have to conditionally render the icon below instead of using hideBelow = wide because the spacing is still applied when the columns are collapsed 
            even if the column is hidden which causes unwanted white space */}
          {isWide ? (
            <Column width="content">
              <Heading level="4" component="span">
                <span className={styles.searchItemIcon}>{icon}</span>
              </Heading>
            </Column>
          ) : null}
          <Column>
            <Stack space="xxsmall">
              <Text
                size="standard"
                tone="neutral"
                baseline={false}
                maxLines={summary ? 1 : 2}
              >
                {label}
              </Text>
              {summary ? (
                <Text size="standard" tone="secondary" maxLines={1}>
                  {summary}
                </Text>
              ) : null}
            </Stack>
          </Column>
          {count ? (
            <Column width="content">
              <Badge tone="positive">{count}</Badge>
            </Column>
          ) : null}
        </Columns>
      </Box>
    </Link>
  );
};
